var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H35.9883C42.6157 0 47.9883 5.37258 47.9883 12V35.9883C47.9883 42.6157 42.6157 47.9883 35.9883 47.9883H12C5.37258 47.9883 0 42.6157 0 35.9883V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9902 19.9967C31.646 19.9967 32.9883 18.6545 32.9883 16.9987C32.9883 15.3429 31.646 14.0006 29.9902 14.0006C28.3345 14.0006 26.9922 15.3429 26.9922 16.9987C26.9922 18.6545 28.3345 19.9967 29.9902 19.9967Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.998 26.9922C19.6538 26.9922 20.9961 25.6499 20.9961 23.9941C20.9961 22.3384 19.6538 20.9961 17.998 20.9961C16.3423 20.9961 15 22.3384 15 23.9941C15 25.6499 16.3423 26.9922 17.998 26.9922Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9902 33.9876C31.646 33.9876 32.9883 32.6454 32.9883 30.9896C32.9883 29.3338 31.646 27.9915 29.9902 27.9915C28.3345 27.9915 26.9922 29.3338 26.9922 30.9896C26.9922 32.6454 28.3345 33.9876 29.9902 33.9876Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5859 25.5032L27.4115 29.4806",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4015 18.5077L20.5859 22.4851",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/social-icon.9a09875d65c03696eb17f3e218597573.svg";
export { ForwardRef as ReactComponent };